<template>
  <i
    :class="[
      'mdi-' + name,
      color,
      size && 'mdi-' + size + 'px',
      rotate && 'mdi-rotate-' + rotate,
      flip && 'mdi-flip-' + flip,
      spin && 'mdi-spin'
    ]"
    :click="click"
    class="icon mdi"
  />
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    color: {
      validator(v) {
        return [
          'red',
          'orange',
          'yellow',
          'olive',
          'green',
          'teal',
          'blue',
          'violet',
          'purple',
          'pink',
          'brown',
          'grey',
          'black'
        ].includes(v)
      },
      default: 'black'
    },
    size: {
      type: String,
      default: '18'
    },
    rotate: { type: String, default: '' },
    flip: { type: String, default: '' },
    spin: Boolean,
    click: { type: Function, default: null }
  }
}
</script>
